import { render } from "./Ycomloading.vue?vue&type=template&id=828c0282&scoped=true"
import script from "./Ycomloading.vue?vue&type=script&lang=js"
export * from "./Ycomloading.vue?vue&type=script&lang=js"

import "./Ycomloading.vue?vue&type=style&index=0&id=828c0282&scoped=true&lang=css"

import exportComponent from "D:\\A-daima\\前端\\前台\\前台\\nonferrous_metals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-828c0282"]])

export default __exports__